export default "__VITE_ASSET__BKXE3eZD__"